import { Map } from 'immutable';
// - Import action types
import { VoteActionType } from 'constants/voteActionType';
import { VoteState } from './VoteState';
/**
 * Vote actions
 * @param {object} state
 * @param {object} action
 */
export var voteReducer = function (state, action) {
    if (state === void 0) { state = Map(new VoteState()); }
    var payload = action.payload;
    switch (action.type) {
        /* _____________ CRUD _____________ */
        case VoteActionType.ADD_VOTE:
            return state
                .setIn(['postVotes', payload.postId, payload.userId], payload);
        case VoteActionType.ADD_VOTE_LIST:
            return state
                .set('postVotes', payload)
                .set('loaded', true);
        case VoteActionType.DELETE_VOTE:
            return state
                .deleteIn(['postVotes', payload.postId, payload.userId]);
        case VoteActionType.CLEAR_ALL_DATA_VOTE:
            return Map(new VoteState());
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/votes/voteReducer.ts
// module id = 575
// module chunks = 50